import React, { useRef } from "react";
import PropTypes from "prop-types";
import { TinySliderNav, SlideItem } from "@euroland/react";
import { classNames } from "../utils";
import Tag from "./ui/Tag";
import Badge from "./ui/Badge";
import useInstruments, { useInstrument } from "../hooks/useInstruments";
import { useFormatSetting } from "../hooks/useCompanySettings";
import i18n from "@euroland/libs/locale/i18n";
import { MARKET_STATUS, POSITIVE_CHANGE_NUMBER_FORMAT } from "../constant/common";
import { number } from "@euroland/format-number";

export default function MultipleTickerSlider() {
  const [{ instruments }] = useInstruments();
  const [{ selectedInstrument }, { onChangeSelectedInstrument }] = useInstrument();
  const tinySliderRef = useRef();
  let activeOrder = instruments.findIndex(
    instrument => instrument.instrumentId === selectedInstrument.instrumentId
  );
  activeOrder = activeOrder === -1 ? 0 : activeOrder;

  return (
    <div className="vertical-lines">
      <div
        className="MultipleTickerSlider"
      >
        <TinySliderNav
          ref={tinySliderRef}
          isRtl={window.appSettings.isRtl}
          settings={{ gutter: 0 }}
          activeOrder={activeOrder}
          role="listbox"
          aria-orientation="horizontal"
          aria-label={i18n.translate("tickerAriaLabel")}
        >
          {instruments.map((ticker, index) => (
            <TickerItem
              sliderIndex={index}
              key={index}
              active={ticker.instrumentId === selectedInstrument.instrumentId}
              onClick={() => {
                // tinySliderRef.current.goTo(index); // new version tiny will scroll to Item clicked
                onChangeSelectedInstrument(ticker.instrumentId);
              }}
              ticker={ticker}
            />
          ))}
        </TinySliderNav>
      </div>
    </div>
  );
}

/**
 *
 * @param {{
 *  active: boolean,
 *  ticker: import("../..").IInstrument,
 *  onClick: () => void,
 * }} props
 * @returns
 */
export function TickerItem({ active, ticker, onClick, sliderIndex }) {
  const format = useFormatSetting();
  return (
    <SlideItem
      className={classNames("TickerItem", { active })}
      onClick={onClick}
      sliderIndex={sliderIndex}
      role="option"
      aria-selected={active}
    >
      <div className="title-wrapper">
        <Badge active={ticker.marketStatus === MARKET_STATUS.OPEN} />
        <h2 title={ticker.shareName}>{ticker.shareName}</h2>
        <Tag label={ticker.marketAbbreviation} aria-label={ticker.marketName} />
      </div>
      <div className="value-wrapper">
        <p className="value">{number(ticker.last)}</p>
        <p className="currency">{ticker.currencyCode}</p>
      </div>
      <div className="flex-bottom">
        <div
          className={classNames("change-wrapper", {
            "indicator--up": ticker.change > 0,
            "indicator--down": ticker.change < 0,
            "indicator--natural": ticker.change === 0,
          })}
        >
          <p
            className={classNames("change-value", {
              "change-up": ticker.change > 0,
              "change-down": ticker.change < 0,
            })}
          >
            {number(ticker.change, undefined, {
              positiveFormatPattern: format?.positiveChangeFormat || POSITIVE_CHANGE_NUMBER_FORMAT,
            })}
          </p>

          <div
            className={classNames("change-percent", {
              "change-up": ticker.changePercentage > 0,
              "change-down": ticker.changePercentage < 0,
            })}
          >
            (
            {number(ticker.changePercentage, undefined, {
              positiveFormatPattern: format?.positiveChangeFormat || POSITIVE_CHANGE_NUMBER_FORMAT,
            })}
            %)
          </div>
        </div>
      </div>
    </SlideItem>
  );
}

MultipleTickerSlider.propTypes = {};
TickerItem.prototype = {
  ticker: PropTypes.exact({
    id: PropTypes.number,
    default: PropTypes.bool,
    tickerName: PropTypes.string,
    marketName: PropTypes.string,
    currencySign: PropTypes.string,
    numberOfTrade: PropTypes.number,
  }),
  onClick: PropTypes.func,
};
